import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

jQuery(document).ready(() => {
    jQuery('.latest__slider').each(function () {
        const container = jQuery(this);

        new Swiper(container[0], {
            modules: [Pagination],
            loop: true,
            slidesPerView: 1,
            spaceBetween: 20,

            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },

                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },

                1200: {
                    slidesPerView: 3,
                    spaceBetween: 69,
                },
            },

            pagination: {
                el: container.find('.swiper-pagination')[0],
                clickable: true,
            },
        });
    });
});